export const FACEBOOK_ID__MEERKATS_STAGING = '725576127598110';
export const FACEBOOK_ID__MEERKATS_DEV = '1244816268918760';
export const FACEBOOK_ID__IGNIA_DEV = 289434864860446; //'690430101131029';
export const FACEBOOK_ID__PEET = '289434864860446';
